import React from 'react';

// Loading Page component with smooth transitions and animations of skeletons
const LoadingPage: React.FC = () => {
  const loadingStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#1a1a2e',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    zIndex: 9999,
    animation: 'fadeIn 0.3s ease-in',
    paddingTop: 'calc(20px + var(--safe-area-inset-top))',
    paddingBottom: 'calc(20px + var(--safe-area-inset-bottom))',
    paddingLeft: 'calc(20px + var(--safe-area-inset-left))',
    paddingRight: 'calc(20px + var(--safe-area-inset-right))',
    boxSizing: 'border-box',  
};

  const skeletonContainerStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '800px',
    padding: '0 20px',
  };

  const skeletonRowStyle: React.CSSProperties = {
    display: 'flex',
    gap: '16px',
    marginBottom: '16px',
    alignItems: 'center',
  };

  const skeletonStyle: React.CSSProperties = {
    height: '20px',
    backgroundColor: '#2e2e47',
    borderRadius: '8px',
    animation: 'pulse 1.5s ease-in-out infinite',
  };

  return (
    <div className="loading-container" style={loadingStyle}>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        
        @keyframes fadeIn {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        
        @keyframes slideUp {
          0% { transform: translateY(20px); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }

        /* Increase top padding for small and medium screens (e.g., 768px and lower) */
        @media (max-width: 768px) {
            .loading-container {
                padding-top: 80px !important;
            }
        }

      `}</style>
      
      {/* Page skeleton with smooth animations */}
      <div style={{...skeletonContainerStyle, animation: 'slideUp 0.5s ease-out 0.2s both'}}>
        {/* Header skeleton */}
        <div style={skeletonRowStyle}>
          <div style={{...skeletonStyle, width: '60px', height: '40px'}}></div>
          <div style={{...skeletonStyle, flex: 1, height: '24px'}}></div>
          <div style={{...skeletonStyle, width: '100px', height: '36px'}}></div>
        </div>
        
        {/* Main content skeleton */}
        <div style={{marginTop: '40px'}}>
          <div style={{...skeletonStyle, width: '300px', height: '32px', marginBottom: '20px'}}></div>
          <div style={{...skeletonStyle, width: '100%', height: '20px', marginBottom: '12px'}}></div>
          <div style={{...skeletonStyle, width: '85%', height: '20px', marginBottom: '12px'}}></div>
          <div style={{...skeletonStyle, width: '70%', height: '20px', marginBottom: '30px'}}></div>
          
          {/* Cards skeleton */}
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px'}}>
            {[1, 2, 3].map((i) => (
              <div key={i} style={{
                padding: '20px',
                backgroundColor: '#16213e',
                borderRadius: '12px',
                animation: `slideUp 0.5s ease-out ${0.3 + i * 0.1}s both`
              }}>
                <div style={{...skeletonStyle, width: '100%', height: '120px', marginBottom: '16px'}}></div>
                <div style={{...skeletonStyle, width: '80%', height: '20px', marginBottom: '8px'}}></div>
                <div style={{...skeletonStyle, width: '60%', height: '16px'}}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;